"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungslaengeUeberstandLock = void 0;
var LeitungslaengeUeberstandLock;
(function (LeitungslaengeUeberstandLock) {
    LeitungslaengeUeberstandLock["none"] = "none";
    LeitungslaengeUeberstandLock["laengeOnly"] = "laengeOnly";
    LeitungslaengeUeberstandLock["festpunktOnly"] = "festpunktOnly";
    LeitungslaengeUeberstandLock["mitnehmerOnly"] = "mitnehmerOnly";
    LeitungslaengeUeberstandLock["laengeAndFestpunkt"] = "laengeAndFestpunkt";
    LeitungslaengeUeberstandLock["laengeAndMitnehmer"] = "laengeAndMitnehmer";
    LeitungslaengeUeberstandLock["festpunktAndMitnehmer"] = "festpunktAndMitnehmer";
})(LeitungslaengeUeberstandLock = exports.LeitungslaengeUeberstandLock || (exports.LeitungslaengeUeberstandLock = {}));
//# sourceMappingURL=LeitungslaengeUeberstandLock.js.map